import { Component, OnInit } from '@angular/core';
import { environment } from "../../environments/environment";
import { CartService } from "../services/cart/cart.service";
@Component({
  selector: 'app-favoris',
  templateUrl: './favoris.component.html',
  styleUrls: ['./favoris.component.css']
})
export class FavorisComponent implements OnInit {


  favoris=[];
  baseUrl = environment.baseUrl
  constructor(private cartService:CartService) {
    // localStorage.removeItem('favoris');
    // localStorage.clear()
    if (localStorage.getItem('favoris')) {
      this.favoris = JSON.parse(localStorage.getItem('favoris'));
    }
  }

  removeItem(id)
  {
    this.favoris.forEach(itemCard => {
      if (id==itemCard.ITMREF)
      {
        var index = this.favoris.indexOf(itemCard)
        this.favoris.splice(index, 1);
        this.cartService.favorisCount--;

        localStorage.setItem('favoris',JSON.stringify(this.favoris));
        if (this.favoris.length == 0) {
          localStorage.removeItem('favoris')
        }
      }
    });
  }

  ngOnInit(): void {

  }

}
